import React, { useState, useEffect, useRef, useContext } from 'react'
import { Grid, Box, Button, Typography } from '@mui/material'
import { array, func } from 'prop-types'
import dayjs from 'dayjs'
import ptBR from 'dayjs/locale/pt-br'
import sistema from '../../services/http/sistema'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Dater from '../../services/DateFormat'
import BaseAutoComplete from '../shared/BaseAutoComplete'
import { Bibliotecarios, Emprestimos, Exemplares } from '../../services/http/'
import Leitores from '../../services/http/leitores/Leitores'
import SmallTextField from '../textfield/SmallTextfield'
import getUser from '../../services/http/user/getUser'
import { PermissionsContext } from '../../providers/permissions'
const FormEmprestimo = ({ onSubmitEnd = () => {} }) => {
  const { hasThisPermission } = useContext(PermissionsContext)

  const [leitores, setLeitores] = useState([])
  const [exemplares, setExemplares] = useState([])
  const resetExemplar = useRef()
  const resetLeitor = useRef()

  const [form, setForm] = useState({
    exemplar_id: null,
    leitor_id: null,
    data_prevista_devolucao: dayjs()
  })
  const [exemplaresEmprestados, setExemplaresEmprestados] = useState([])

  const submit = async event => {
    event.preventDefault()
    const currentDate = form.data_prevista_devolucao.format()
    const data = {
      ...form,
      data_prevista_devolucao: Dater().formatar(currentDate, 'yyyy-mm-dd')
    }

    const resp = await sistema().emprestimos().store(data, {
      notification: true,
      message: 'Exemplar emprestado com Sucesso!'
    })
    onSubmitEnd(resp)
    resetExemplar.current()
    resetLeitor.current()
    getEmprestimos()
  }

  const getLeitores = async bibliotecas => {
    const result =
      bibliotecas.length > 0 ? { biblioteca_id: bibliotecas.toString() } : {}
    const { data } = await Leitores().show({
      per_page: -1,
      includes: 'user',
      'includes[user][ativo]': true,
      ...result
    })
    const leitores = data.data.map(item => ({ ...item, nome: item.user.name }))
    setLeitores(leitores)
  }

  const getExemplares = async bibliotecario => {
    const { data } = await Exemplares().show({
      per_page: -1,
      includes: 'obra',
      biblioteca_id: bibliotecario.toString()
    })
    const obras = data.data.map(item => ({
      ...item,
      titulo: `cod:${item.id} - ${item.obra.titulo}`
    }))
    setExemplares(obras)
  }

  const dateDevolution = () => {
    const currentDate = new Date()
    currentDate.setDate(currentDate.getDate() + 30)
    const day = currentDate.getDate()
    const month = currentDate.getMonth() + 1
    const year = currentDate.getFullYear()

    setForm({ data_prevista_devolucao: dayjs(`${year}-${month}-${day}`) })
  }

  useEffect(() => {
    init()
    getEmprestimos()
    dateDevolution()
  }, [])

  const getEmprestimos = async () => {
    const { data } = await Emprestimos().show({ per_page: -1 })
    const result = data.data.map(item => item.exemplar_id)
    setExemplaresEmprestados(result)
  }

  const init = async () => {
    const user = await getUser()

    const { data } = await Bibliotecarios().show({
      'includes[user][id]': user.id
    })

    if (data.data) {
      const arrayBibliotecas = []
      data.data.map(item => arrayBibliotecas.push(item.biblioteca_id))
      getExemplares(arrayBibliotecas)
      getLeitores(
        hasThisPermission({ permission: '', roles: 'gestor' })
          ? []
          : arrayBibliotecas
      )
    }
  }

  return (
    <form onSubmit={submit}>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', p: 0, mb: 2 }}
      >
        <Typography variant="h5"> Empréstimo </Typography>
      </Box>
      <Grid container rowSpacing={1}>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid xs={12} sm={12} item>
              <BaseAutoComplete
                list={exemplares}
                listLabel={'titulo'}
                inputProps={{ label: 'Livro' }}
                Input={SmallTextField}
                onChange={event => setForm({ ...form, exemplar_id: event?.id })}
                getOptionDisabled={option => {
                  return exemplaresEmprestados.includes(option.id)
                }}
                reset={event => {
                  resetExemplar.current = event
                }}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <BaseAutoComplete
                list={leitores}
                listLabel={'nome'}
                Input={SmallTextField}
                inputProps={{ label: 'Leitor' }}
                value={form.leitor}
                onChange={({ id }) => setForm({ ...form, leitor_id: id })}
                reset={event => (resetLeitor.current = event)}
              />
            </Grid>

            <LocalizationProvider
              adapterLocale={ptBR}
              dateAdapter={AdapterDayjs}
            >
              <Grid item xs={12} sm={4}>
                <DatePicker
                  openTo="day"
                  inputFormat="DD/MM/YYYY"
                  views={['day', 'year', 'month']}
                  renderInput={props => <SmallTextField {...props} />}
                  label="Data prevista de Devolução"
                  value={form.data_prevista_devolucao}
                  onChange={newValue => {
                    setForm({ ...form, data_prevista_devolucao: newValue })
                  }}
                />
              </Grid>
            </LocalizationProvider>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} sx={{ mt: '32px' }}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end'
            }}
          >
            <Button type="submit" variant="contained" color="leitura">
              Emprestar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  )
}
FormEmprestimo.propTypes = {
  books: array,
  onSubmitEnd: func
}
export default FormEmprestimo
